import { useTranslation } from 'react-i18next';
import RadioButton from '../../../../../../common/widgets/RadioButton';
import { ProductTypes } from '../../../../enums';
import { ProductTypeModel } from '../../../../models/products';
import { resources } from '../../../../resources/resources';

interface ProductTypeSelectorProps {
  productTypes?: ProductTypeModel[];
  productType?: ProductTypes;
  setProductType: (productType: ProductTypes) => void;
  onBackClick: () => void;
  onContinueClick: () => void;
}

export const ProductTypeSelector = (props: ProductTypeSelectorProps) => {
  const {
    productTypes,
    productType,
    setProductType,
    onBackClick,
    onContinueClick,
  } = props;
  const { t: translate } = useTranslation();
  if (!productTypes) return null;
  return (
    <div className="product-type">
      <div className="m-panel">
        <h1>{translate(resources.products.add.productType.title)}</h1>
        <p className="product-type-copy">
          {translate(resources.products.add.productType.info)}
        </p>
        <ul className="product-type-selector">
          <li>
            <RadioButton
              label={
                productTypes.find(e => e.id === ProductTypes.ProductOrService)
                  ?.name
              }
              checked={productType === ProductTypes.ProductOrService}
              onChange={e => setProductType(e.value)}
              value={ProductTypes.ProductOrService}
            />
            <span>
              {translate(
                resources.products.add.productType.productOrServiceInfo,
              )}
            </span>
          </li>
          <li>
            <RadioButton
              label={
                productTypes.find(e => e.id === ProductTypes.GiftCard)?.name
              }
              checked={productType === ProductTypes.GiftCard}
              onChange={e => setProductType(e.value)}
              value={ProductTypes.GiftCard}
            />
            <span>
              {translate(resources.products.add.productType.giftCardInfo)}
            </span>
          </li>
          <li>
            <RadioButton
              label={
                productTypes.find(e => e.id === ProductTypes.PercentageVoucher)
                  ?.name
              }
              checked={productType === ProductTypes.PercentageVoucher}
              onChange={e => setProductType(e.value)}
              value={ProductTypes.PercentageVoucher}
            />
            <span>
              {translate(resources.products.add.productType.percentageVoucher)}
            </span>
          </li>
          <li>
            <RadioButton
              label={
                productTypes.find(e => e.id === ProductTypes.ValueVoucher)?.name
              }
              checked={productType === ProductTypes.ValueVoucher}
              onChange={e => setProductType(e.value)}
              value={ProductTypes.ValueVoucher}
            />
            <span>
              {translate(resources.products.add.productType.valueVoucher)}
            </span>
          </li>
        </ul>
      </div>
      <div className="m-actions-panel">
        <button onClick={onBackClick} className="btn btn-outline">
          <span className="btn-text">{translate(resources.back)}</span>
        </button>
        <button
          onClick={onContinueClick}
          className="btn btn-solid"
          disabled={!productType}
        >
          <span className="btn-text">
            {translate(resources.saveAndContinue)}
          </span>
        </button>
      </div>
    </div>
  );
};
